@import { NavLink } from "@source-crafter/xzor-runtime"
@import NavBar from "@source-crafter/xzor-ui/NavBar.xzor"
@import Button from "@source-crafter/xzor-ui/Button.xzor"
@import { currentTheme, toggleTheme } from "@source-crafter/xzor-ui"
@import { href } from "../routes"

@code {
  theme = currentTheme();

  flip() {
    this.theme = toggleTheme();
  }
}

<NavBar kind="top" label="Site">
  <a class="brand" href="@href.Home()"><span class="at">@@</span>xzor</a>
  <span class="xz-spacer"></span>
  <div class="links">
    <NavLink href="@href.Start()">Get started</NavLink>
    <NavLink href="@href.Learn({ step: 1 })">Learn</NavLink>
    <NavLink href="@href.Kit()">Kit</NavLink>
    <NavLink href="@href.Showcase()">Examples</NavLink>
    <NavLink href="@href.Recipes()">Recipes</NavLink>
    <NavLink href="@href.HowItWorks()">How it works</NavLink>
    <NavLink href="@href.Roadmap()">Roadmap</NavLink>
    <a href="https://github.com/pedro-gilmora/source-crafter-xzor" rel="external">GitHub</a>
  </div>
  <Button variant="ghost" icon="@(theme === 'dark' ? 'sun' : 'moon')" label="@(theme === 'dark' ? 'Use light theme' : 'Use dark theme')" onClick="flip" />
</NavBar>
<main>
  @slot
</main>
<footer>
  This site is an xzor app styled with the xzor-ui kit: its pages are <code>.xzor</code> components, and its code samples are highlighted at build time with the same grammar as the VS Code extension.
</footer>
